import BaseModel from '../core/BaseModel'
//import gql from 'graphql-tag'
export default class TypeWorkModel extends BaseModel {

    constructor() {
        super({
                name: "type_work",
                tableName: 'type_work',
                label: "Loại công việc",
            },
            {
                stt: {
                    name: "stt",
                    label: "STT",
                    type: "Computed",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                    // display: { list: true, add: false, edit: false }
                },
                id: {
                    name: "id",
                    display: false
                },
                code: {
                    name: "code",
                    display: false
                },
                name:{
                    name: "name",
                    label: "Tên công việc",
                    type: "String",
                    class: "center",
                    display: false
                },
            },
            )
    }

}